import { FilterConfig, FilterGroup, FilterName, FiltersList, FilterWithOptions } from './types';
import {
  AssetGIQueryParams,
  AssetSelfTestQueryParams,
  AssetsListQueryParams,
  AssetVIQueryParams,
} from '@customer/store/apis/assetsApi';
import { FiltersState } from '@customer/store/slices/filtersSlice';
import { ScenarioQueryParams } from '@customer/store/apis/scenariosApi';
import { AssetHealthQueryParams, HealthSummaryQueryParams } from '@customer/store/apis/healthApi';
import {
  ASSET_GI_FILTERS,
  ASSET_LIST_FILTERS,
  ASSET_SELF_TEST_FILTERS,
  ASSET_VI_FILTERS,
  FILTERS_CONFIG,
  HEALTH_REPORTING_FILTERS,
  HEALTH_SELF_TEST_FILTERS,
  HEALTH_SOFTWARE_STATUS_FILTERS,
  HEALTH_SUMMARY_FILTERS,
  INVESTIGATIONS_FILTERS,
  PARTNER_RESOURCES_FILTERS,
  PERFORMANCE_GI_FILTERS,
  PERFORMANCE_VI_FILTERS,
  TECH_LIBRARY_FILTERS,
} from './config';
import {
  PartnerResourcesQueryParams,
  TechLibraryQueryParams,
} from '@customer/store/apis/documentsApi';
import { InvestigationsQueryParams } from '@customer/store/apis/investigationsApi';

export const getFiltersList = (filterGroup: FilterGroup): FiltersList => {
  switch (filterGroup) {
    case FilterGroup.AssetsList:
      return ASSET_LIST_FILTERS;
    case FilterGroup.AssetSelfTest:
      return ASSET_SELF_TEST_FILTERS;
    case FilterGroup.AssetGI:
      return ASSET_GI_FILTERS;
    case FilterGroup.AssetVI:
      return ASSET_VI_FILTERS;
    case FilterGroup.HealthSummary:
      return HEALTH_SUMMARY_FILTERS;
    case FilterGroup.HealthSelfTest:
      return HEALTH_SELF_TEST_FILTERS;
    case FilterGroup.HealthSoftwareStatus:
      return HEALTH_SOFTWARE_STATUS_FILTERS;
    case FilterGroup.HealthReporting:
      return HEALTH_REPORTING_FILTERS;
    case FilterGroup.Investigations:
      return INVESTIGATIONS_FILTERS;
    case FilterGroup.PartnerResources:
      return PARTNER_RESOURCES_FILTERS;
    case FilterGroup.PerformanceGI:
      return PERFORMANCE_GI_FILTERS;
    case FilterGroup.PerformanceVI:
      return PERFORMANCE_VI_FILTERS;
    case FilterGroup.TechLibrary:
      return TECH_LIBRARY_FILTERS;
  }
};

export type AllowedQueryParams =
  | AssetsListQueryParams
  | AssetSelfTestQueryParams
  | AssetHealthQueryParams
  | AssetGIQueryParams
  | AssetVIQueryParams
  | HealthSummaryQueryParams
  | InvestigationsQueryParams
  | PartnerResourcesQueryParams
  | ScenarioQueryParams
  | TechLibraryQueryParams;

export const getFilterName = (filter: FilterName | FilterWithOptions): FilterName => {
  return typeof filter === 'string' ? filter : filter.name;
};

export const getFilterNamesFromFiltersList = (filtersList: FiltersList): FilterName[] => {
  return filtersList.map(
    (filter: FilterName | FilterWithOptions): FilterName => getFilterName(filter),
  );
};

export const getRelevantFilters = <T extends AllowedQueryParams>(
  savedFilters: FiltersState,
  filterNames: FilterName[],
): T => {
  // @ts-expect-error FIXME: This correct, type-safe code needs correct types.
  const relevantFilters: T = {};

  filterNames.forEach((name: FilterName) => {
    // @ts-expect-error FIXME: This correct, type-safe code needs correct types.
    relevantFilters[name] = savedFilters[name];
  });

  return relevantFilters;
};

export const getFilterConfig = (
  filter: FilterName | FilterWithOptions,
): FilterConfig | undefined => {
  return FILTERS_CONFIG.find(({ name }) => name === getFilterName(filter));
};
